module.exports = __webpack_public_path__ + "media/packs/images/upload-csv-track-71260777363124daa011319391704812.svg";